import getIn from 'lodash/get';
import noop from 'lodash/noop';
import { call, put, select } from 'redux-saga/effects';

import * as D from '../../deps';
import * as PlaybackServices from '../../services';
import * as PlaybackUtils from '../../utils';

export function* onIntentToPlay({ data }) {
  if (data.userTimedOut) {
    yield put(D.getInDomain('analytics.actions.ttmStillListening', noop)());
  } else if (!data.dontDispatchPlaybackResumed) {
    yield put(D.getInDomain('analytics.actions.ttmPlaybackResumedTransitionFromMusic', noop)());
  }
  const isAPS = yield select(PlaybackUtils.isPlaylistModelTypeAPSItem);
  if (isAPS) {
    yield call(D.putAndWait, D.getInDomain('playback.actions.resumeSource')());
  } else {
    const id = data.id || (yield select(D.getInDomain('playback.utils.getCurrentPlaylist')));
    yield call(
      D.putAndWait,
      D.getInDomain('playback.actions.playTrackFromStation')({
        ...data,
        id,
      }),
    );
    getIn(
      window,
      'DesktopBridge.playOrPauseMedia',
      noop,
    )(
      true,
      D.Utils.SourceType.getDesktopBridgeSourceType(D.Constants.SourceTypes.SourceTypes.STATION),
    );
  }
}

export function* forceActiveListenerWhenAudioIsPlaying() {
  const isAudioPlaying = yield select(PlaybackUtils.isAudioPlaying);
  if (isAudioPlaying) {
    yield call(PlaybackServices.playbackResumed, true);
  }
}
